__turbopack_context__.v({
  "description": "WizardHeader-module-scss-module__zshhyW__description",
  "title": "WizardHeader-module-scss-module__zshhyW__title",
});
